module.exports = __webpack_public_path__ + "img/burn-zero.7e146142.png";